<div class="position-relative">
  <div class="container min-height-xs-100vh">
      <div class="row pt-5 pb-2 mx-auto text-center">
        <h1 class="text-white font-weight-bold">Refund and Cancellation Policy</h1>
      </div>
      <div class="container space-bottom-2 px-lg-12">
        <div class="row my-4 mt-4">
          <div class="col-12 col-lg-12 p-6 transparent-card">
          <p class="mainBody">
            Thanks for booking with Kopa Tours for your trip of a lifetime! We know that life happens
            and plans can change, we're here to help.
          </p>
          <br/>
          <h3>Refund and Cancellation Policy</h3>
          <br/>
          <h4>If booking is cancelled and communicated to Kopa Tours:</h4>
          <ul class="my-4">
          <li>
          <h5 class="pricingHeader pl-3">61 days prior to day of arrival at destination,</h5>
          <p class="mainBody pl-5">You will receive a full refund -- there is no cancellation fee and money provided to Kopa Tours will be returned within sixty (60) days of the cancellation.</p>
          </li>
          <li>
          <h5 class="pricingHeader pl-3">30 to 60 days prior to departure,</h5>
          <p class="mainBody pl-5">You will receive a 70% refund.</p>
          </li>
          <li>
          <h5 class="pricingHeader pl-3">14 to 29 days prior to departure,</h5>
          <p class="mainBody pl-5">You will receive a 40% refund.</p>
          </li>
          <li>
          <h5 class="pricingHeader pl-3">13 days or fewer prior to departure,</h5>
          <p class="mainBody pl-5">You will receive <i>no refund</i> and all outstanding payment will become due and payable immediately.</p>
          </li>
          </ul>
          <h3>Payment Plan(s)</h3>
          <br/>
          <p class="mainBody">If booking <b>more</b> than sixty days (&gt;60) in advance, <b>20%</b> downpayment is required.
          <br>If booking <b>less</b> than sixty (&lt;60) days before departure, payment must be <b>made in full</b>.
          </p>
          <br/>
          <h3>"No Shows"</h3>
          <br/>
          <p class="mainBody">
            Please note that we offer no refunds or any type of reimbursement for “no-shows”, or any extra costs due to the nature of a "no-show". If you or your party arrived on the wrong date, arrived at
            the wrong pick-up point or for any other reason do not show up to join the tour our policy offers 0% refunds. At Kopa Tours, we will do our best to guide
            and help you to your destination; however, it’s solely your responsibility to arrive at the respective tour departure date and location outlined in your booking.
          </p>
          <br/>
          <h3>Cancellation Due to Illness</h3>
          <br/>
          <p class="mainBody">
            Please note that we offer no refunds or reimbursement for illness or other medical conditions that may result in you or your party not being able to participate in a tour.
            If you need to cancel your tour due to illness or other medical condition please refer to our standard cancellation and refund policy outlined above.
          </p>
          <br/>
          <h3>Rescheduling under our "Flexible Booking Guarantee"</h3>
          <br/>
          <p class="mainBody">
            Your vacation with Kopa Tours includes a Flexible Booking Guarantee.
            Cancel and rebook your tour up to 15 days before departure without fees.
          </p>
          <p class="mainBody">
            If you have difficulties with the departure date, after your free reschedule* - the above standard Refund & Cancellation policy applies.
            <br><br>
            * <small>Limit 1 reschedule per booking.</small>
          </p>
          </div>
        </div>
      </div>
  </div>
</div>
